import BackendService from './BackendService';

async function getStockReport(data = {}, params) {
  return BackendService.post('/stock_reports/', data, {}, params);
}
async function getManualStockAdjustmentReport(data = {}, params) {
  return BackendService.post('/reports/manual-stock-adjustment/', data, {}, params);
}
async function getItemStockTransactions(item_id, data) {
  return BackendService.getData(`/items/${item_id}/stock_logs/`, {}, data);
}

async function getStockSummaryReport() {
  return BackendService.postData('/reports/stock-summary/');
}

async function getExpiringStockReport(data = {}, params) {
  return BackendService.post('/reports/expiring-item-stock/', data, {}, params);
}

async function getExpiredStockReport(data = {}, params) {
  return BackendService.post('/reports/expired-item-stock/', data, {}, params);
}

async function getStockConsumptionReport(params = {}) {
  return BackendService.getData('/stock_logs/', {}, params);
}

async function createStockConsumption(data, warehouseId = '') {
  const params = {
    consumption: true,
    create_consumption_log: true,
  };
  if (warehouseId) {
    params.warehouse_id = warehouseId;
  }
  return BackendService.postData('/items/stock/', data, {}, params);
}

async function updateStockLog(stockLogId, data) {
  return BackendService.put(`/stock_logs/${stockLogId}/`, data);
}

async function getSubitemConsumptionReport(data = {}, params) {
  return BackendService.post('/reports/subitem-consumption/', data, {}, params);
}

const StockReportService = {
  getStockReport,
  getManualStockAdjustmentReport,
  getItemStockTransactions,
  getStockSummaryReport,
  getExpiringStockReport,
  getExpiredStockReport,
  getStockConsumptionReport,
  createStockConsumption,
  updateStockLog,
  getSubitemConsumptionReport,
};

export default StockReportService;
